export default {
  KUSPIT_CUSTOMER_DOCUMENT_REPOSITORY: Symbol.for('KUSPIT_CUSTOMER_DOCUMENT_REPOSITORY'),
  KUSPIT_VERIFY_TOKEN_MAGIC_LINK_QUERY: Symbol.for('KUSPIT_VERIFY_TOKEN_MAGIC_LINK_QUERY'),
  KUSPIT_UPLOAD_PROOF_OF_TAX_SITUATION_COMMAND: Symbol.for('KUSPIT_UPLOAD_PROOF_OF_TAX_SITUATION_COMMAND'),
};
